import { render, staticRenderFns } from "./redirectSignup.vue?vue&type=template&id=31d69564&"
import script from "./redirectSignup.vue?vue&type=script&lang=js&"
export * from "./redirectSignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports